import React, { Component,useState } from 'react';
import Button from '@mui/material/Button';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import "../../../index.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import * as apiDashBoardService from '../../NewProcess/apiRequestService';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import PendingIcon from '@mui/icons-material/Pending';
import Moment from 'moment';
import {getApprovalDetail} from '../../NewProcess/apiRequestService';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import styles from '../style.js';
import Stepper from '../../ui/Stepper';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {DownloadFile, DownloadZipFile} from '../../../utils/fileOperation';

class DetailPage extends Component {
 

  constructor(props) {
    super(props);
    this.state = {
      BoxClass:{
        boxShadow: 12
      },
      processInfos:[],
      processDetails:[],
      processSigners:[],
      selectedValue:{},
      steps : [
        'Süreç Başlangıcı',
        'Süreç Onayları',
        'Süreç Sonucu',
      ],
      activeStep:3
    };
  }

  componentDidMount() {
    const {selectedId}=this.props;

    getApprovalDetail(selectedId)
    .then((response) => {
        this.setState({selectedValue: response.data}, () => {this.fillPageDetails();});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Detay bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getApprovalDetail exception: ' + JSON.stringify(exception));
    });
  }

  fillPageDetails() {  
    const{selectedValue}=this.state;

    let rows = [
      {name:"Süreç Adı",detail:selectedValue.name},
      {name:"Süreç Grubu",detail:!_.isNil(selectedValue.processTypeDetail) && !_.isNil(selectedValue.processTypeDetail.processGroup)?
      selectedValue.processTypeDetail.processGroup.name:''},
      {name:"Süreç Türü",detail:!_.isNil(selectedValue.processTypeDetail)?selectedValue.processTypeDetail.processTypeName:''},
      {name:"İmzalama Sırası",detail:selectedValue.signOrderTitle},
      {name:"Süreç Sonu Eylemi",detail:selectedValue.endOperationActionTitle}
    ]
    this.setState({processInfos:rows});

    let detailRows = [
      {name:"Süreç Bilgilendirme",detail:selectedValue.notificationTypeTitle},
      {name:"Süreç Sonu Bilgilendirme",detail:selectedValue.endProcessNotificationTypeTitle},
      {name:"Süreç Kayıt Tarihi",detail:Moment(selectedValue.createdDate).format('DD/MM/YYYY HH:mm')},
      {name:"Süreç Oluşturan",detail:selectedValue.createdUser},
      {name:"Dosya Adı",detail:selectedValue.approvalFile.fileName},
      {name:"Zaman Aşımı Tarihi",detail:Moment(selectedValue.lastUpdatedDate).format('DD/MM/YYYY HH:mm')}]
    this.setState({processDetails:detailRows});

    if (!_.isNil(selectedValue.internalSigners)) {
      let signerRows = [];
      for (let i = 0; i < selectedValue.internalSigners.length; i++) {
        let value=selectedValue.internalSigners[i];
        signerRows.push({
          name:value.userInfo.name,
          detail:value.signType.parameterName,
          recordStatus:value.recordStatus,
          updateDate:value.lastUpdatedDate});
      }
      this.setState({processSigners:signerRows});
    }
  }

  handleViewDoc = () => {
    const { selectedValue } = this.state;
    
    Promise.all([
      apiDashBoardService.getApprovalFile(selectedValue.id),
      apiDashBoardService.getAdditionalFile(selectedValue.id),
    ])
      .then(([approvalFileResponse, additionalFileResponse]) => {
        const approvalFile = approvalFileResponse.data;
        const additionalFile = additionalFileResponse.data;
  
        if (!approvalFile) {
          throw new Error("Süreç dokümanı bulunamadı.");
        }
  
        const filesToDownload = [];
  
        filesToDownload.push({
          fileData: approvalFile.fileData,
          fileName: approvalFile.fileName,
          type: "approval",
        });
  
        if (additionalFile)
          filesToDownload.push({
            fileData: additionalFile.fileData,
            fileName: additionalFile.fileName,
            type: "additional",
          });
  
        if (filesToDownload.length === 1) {
          const file = filesToDownload[0];
          DownloadFile(file.fileData, file.fileName);
        } else {
          DownloadZipFile(filesToDownload);
        }
      })
      .catch((exception) => {
        this.props.actions.setNotification("Dosya bilgileri getirilemedi, daha sonra tekrar deneyin.", "error");
        console.log('handleViewDoc exception: ' + JSON.stringify(exception));
      });
  }

  handleChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });
  };

  render() {
    const { BoxClass,processInfos,processDetails,processSigners,steps,activeStep} = this.state;

    
    function getUserIcon(recordStatus) {
    switch (recordStatus) {
      case "O":
        return (<TableCell sx={{width:"10%"}}><ThumbUpAltIcon sx={{color: "#57853f",fontSize: 30}}/></TableCell>);
      case "R":
        return (<TableCell sx={{width:"10%"}}><ThumbDownIcon sx={{color: "#ab3c3c",fontSize: 30}}/></TableCell>);
      default:
        return (<TableCell sx={{width:"10%"}}><PendingIcon sx={{color: "#ff8d00",fontSize: 30}}/></TableCell>);
    }
  }

  
  function getUserApproveText(recordStatus,updateDate) {
    switch (recordStatus) {
      case "O":
        return (<TableCell><div style={styles.approveText}>Onaylandı</div><div style={styles.dateText}>{Moment(updateDate).format('DD/MM/YYYY HH:mm')}</div></TableCell>);
      case "R":
        return (<TableCell><div style={styles.rejectText}>Reddedildi</div><div style={styles.dateText}>{Moment(updateDate).format('DD/MM/YYYY HH:mm')}</div></TableCell>);
      default:
        return (<TableCell><div style={styles.pendingText}>Bekliyor</div></TableCell>);
    }
  }

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    }));

    function Row(props) { 
      const { row } = props;
      const [open, setOpen] = React.useState(false);
      return (
        <React.Fragment>
          <StyledTableRow>
          {getUserIcon(row.recordStatus)}
          <TableCell component="th" scope="row" sx={styles.cellName}>               
            <strong>{row.name}</strong> 
          </TableCell>
          <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
          {getUserApproveText(row.recordStatus,row.updateDate)}
          {row.recordStatus==="R"?
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              sx={{color: "#ab3c3c"}}
              style={styles.cellName}
              onClick={() => setOpen(!open)}>
              İptal Nedeni {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>:<TableCell />}
        </StyledTableRow>
        <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 ,fontSize: 14}}>
              <div style={styles.cellDetail}>{row.cancelReason}</div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
      </React.Fragment>
      );
    }


    return (
      <div>
        <Box sx={{ width: '100%' }}>
        <Stepper steps={steps} activeStep={activeStep} stepType={'canceled'}/>

        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç İçeriği</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processInfos.map((row) => (
                      <StyledTableRow>
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
              <div className="component">
                <Alert variant="filled" severity="error" style={styles.rejectAlert}>İşlem Zaman Aşımına Uğradı.</Alert>
              </div>                  
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
                <div className='sameLine' style={{ width: '30%'}}>
                  <Button onClick={this.handleViewDoc} style={styles.button} sx={{backgroundColor: '#386c99'}} variant="contained" >
                    Dosya İndir
                  </Button>
                </div>        
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç İmzacıları</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processSigners.map((row) => (
                      <Row key={row.name} row={row} />
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={BoxClass} className="noShadow">        
              <div className="headerStyle"><h4>Süreç Ayrıntıları</h4></div>
              <div className="component" >
                <Table aria-label="simple table">
                  <TableBody>
                    {processDetails.map((row) => (
                      <StyledTableRow>
                        <TableCell component="th" scope="row" sx={styles.cellName}>               
                          <strong>{row.name}</strong> 
                        </TableCell>
                        <TableCell sx={styles.cellDetail}>{row.detail}</TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>                  
            </Box>
          </Grid>

        </Grid>
        </Box>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(DetailPage);